const bulk=a=>a.map(a=>({handler:a.handler,linkId:a.linkId,order:a.order,master_id:a.master_id,data:{meta:a.linkMeta,options:a.linkOptions}}));export{bulk};